<template>
    <div class="add-resource">
        <!-- type select bar -->
        <div class="s space-between change-type-bar v-center" v-if="selectedType">
            <div>
                <div v-if="selectedType === 'MACHINE'" class="v-center">
                    <span class="mr-1"><img src="~@/assets/images/icons/machine-icon.svg" width="12px" /></span> Adding
                    Machine
                </div>
                <div v-else-if="selectedType === 'TOOL'" class="v-center">
                    <span class="mr-1"><img src="~@/assets/images/icons/tool-icon.svg" width="12px" /></span> Adding
                    Tool
                </div>
            </div>
            <div @click="selectedType = null" class="pointer change-type-link">
                Change Type
            </div>
        </div>
        <!-- machine form -->
        <div class="machine-form" v-if="selectedType === 'MACHINE'">
            <div class="mt-2">
             <part-id-preview
             :components="partIdRules"
             v-if="partIdRules.length"
             @update="updatePartIdValues"
             title="Part Id Preview"/>
            </div>
            <div class="mt-2">
                <div class="input-group imp" data-validation="name">
                    <label class="key">Select From Resource Master:</label>
                    <custom-dropdown :list="filteredResources" :selected="selectedResource" @select="handleResourceSelection"
                        @toggle="() => resourceSearchKeyword = ''" @deselect="handleResourceDeselection"
                        class="form-template-container-wft">
                        <template #before-items>
                            <div class="fh center py-4" v-if="loadingResources && resources.length === 0">
                                <loading-circle />
                            </div>
                            <!-- <div class="fh center py-4 s" v-else-if="resources.length === 0">
                                No Resources
                            </div> -->
                            <div class="fh center p-3 form-template-container-wft-search-box" v-else>
                                <input type="text p-2" class="form-template-container-wft-input"
                                    v-model="resourceSearchKeyword" placeholder="Search" />
                            </div>
                            <!-- <div class="fh center py-4" v-if="resources.length !== 0 && filteredResources.length === 0">
                                No Resources
                            </div> -->
                        </template>
                    </custom-dropdown>
                </div>
            </div>
            <div class="mt-2">
                <div class="input-group imp" data-validation="name">
                    <label class="key">Machine Name:</label>
                    <input v-model="newResource.name" />
                </div>
            </div>
            <div class="mt-2">
                <div class="input-group" data-validation="skillsRequired">
                    <label class="key">Skills Required: <span class="required-asterisk">*</span></label>
                        <MultiSelectDropdown
                        :options="skills"
                        @input="handleSkillSelection"
                        placeholder="Select"
                         />

                </div>
            </div>
            <div class="mt-2">
                <div class="input-group imp" data-validation="maintainanceWindow">
                    <label class="key">Maintainance Window:</label>
                    <IntervalSelector @change="handleMaintainanceWindow"/>
                </div>
            </div>
        </div>
        <!-- tool form -->
        <div class="tool-form" v-else-if="selectedType === 'TOOL'">
            <div class="mt-2">
             <part-id-preview
             :components="partIdRules"
             v-if="partIdRules.length"
             @update="updatePartIdValues"
             title="Part Id Preview"/>
            </div>
            <div class="mt-2">
                <div class="input-group imp" data-validation="name">
                    <label class="key">Select From Resource Master:</label>
                    <custom-dropdown :list="filteredResources" :selected="selectedResource" @select="handleResourceSelection"
                        @toggle="() => resourceSearchKeyword = ''" @deselect="handleResourceDeselection"
                        class="form-template-container-wft">
                        <template #before-items>
                            <div class="fh center py-4" v-if="loadingResources && resources.length === 0">
                                <loading-circle />
                            </div>
                            <div class="fh center p-3 form-template-container-wft-search-box" v-else>
                                <input type="text p-2" class="form-template-container-wft-input"
                                    v-model="resourceSearchKeyword" placeholder="Search" />
                            </div>
                        </template>
                    </custom-dropdown>
                </div>
            </div>
            <div class="mt-2">
                <div class="input-group imp" data-validation="name">
                    <label class="key">Tool Name:</label>
                    <input v-model="newResource.name" />
                </div>
            </div>
            <div class="mt-2">
                <div class="input-group" data-validation="skillsRequired">
                    <label class="key">Skills Required: <span class="required-asterisk">*</span></label>
                        <MultiSelectDropdown
                        :options="skills"
                        @input="handleSkillSelection"
                        placeholder="Select"
                         />
                </div>
            </div>
            <div class="mt-2">
                <div class="input-group imp" data-validation="maintainanceWindow">
                    <label class="key">Maintainance Window:</label>
                    <IntervalSelector @change="handleMaintainanceWindow"/>
                </div>
            </div>
        </div>
        <div class="type-select-menu" v-else>
            <h3 class="title">What type of resource would you like to add?</h3>

            <div class="options">
                <div class="option-card" @click="selectType('MACHINE')">
                    <div class="icon">
                        <img src="~@/assets/images/icons/machine-icon.svg" />
                    </div>
                    <h4>Machine</h4>
                    <p>CNC, Press, etc.</p>
                </div>

                <div class="option-card" @click="selectType('TOOL')">
                    <div class="icon">
                        <img src="~@/assets/images/icons/tool-icon.svg" />
                    </div>
                    <h4>Tool</h4>
                    <p>Mold, Fixture, Die, etc.</p>
                </div>
            </div>
        </div>
        <div class="flex flex-end mt-3 s" v-if="selectedType">
            <button class="btn btn-black mr-3 pointer" @click="cancel">Cancel</button>
            <button class="btn pointer" @click="save">Add {{ selectedType.charAt(0) + selectedType.toLowerCase().slice(1) }}</button>
        </div>
    </div>
</template>

<script>
import
{
  GetResourceTypes,
  GetResourcesFromResourceMaster,
  GetSkillsRequired,
  CreateResourceInstance,
  ResourceState,
  GetTenantConfigTypes,
  GetIdGenerationRulesByFeatureId
} from '@/api'
import CustomDropdown from '@/components/common/customDropdown.vue'
import MultiSelectDropdown from '@/components/common/customMultiSelect.vue'
import IntervalSelector from '@/components/common/intervalSelector.vue'
import PartIdPreview from '@/components/common/partIdPreview.vue'
import LoadingCircle from '@/components/common/loadingCircle.vue'
import { alert } from '@/plugins/notification'
import config from '@/config'
export default {
  name: 'AddResource',
  components: {
    CustomDropdown,
    MultiSelectDropdown,
    IntervalSelector,
    PartIdPreview,
    LoadingCircle
  },
  data () {
    return {
      selectedType: null,
      resources: [],
      selectedResource: null,
      loadingResources: false,
      resourceSearchKeyword: '',
      resourceType: {},
      partIdRules: [],
      partIdValues: [],
      skills: [],
      newResource: {
        name: '',
        skillsRequired: [],
        maintainanceWindow: {}
      }
    }
  },
  computed: {
    filteredResources () {
      if (this.resourceSearchKeyword.trim() === '') {
        return this.resources
      }
      return this.resources.filter(resource =>
        resource.name.toLowerCase().includes(this.resourceSearchKeyword.toLowerCase())
      )
    }
  },
  mounted () {
    this.getSkills()
    this.getPartIdRules()
  },
  methods: {
    updatePartIdValues (values) {
      this.partIdValues = values
    },
    getPartIdRules () {
      GetTenantConfigTypes().then((res) => {
        const featureId = res.tenant_defaults[0].tenant_feature_configuration?.FACTORIES?.RESOURCES?.SEQUENCE_TEMPLATE_DEFAULT
        if (featureId) {
          GetIdGenerationRulesByFeatureId(featureId, true).then((res) => {
            this.partIdRules = res.id_generation_rules
          })
        }
      })
    },
    validatePartIdValues () {
      let isValid = true
      for (const value of this.partIdValues) {
        const isEmpty = value.value === null || value.value === undefined || value.value === ''
        if (isEmpty) {
          alert(`Please enter a value for ${value.caption} in resource id`)
          isValid = false
        }
      }
      return isValid
    },
    save () {
      if (!this.validateData()) return
      const body = { name: this.newResource.name }
      body.resource_id = this.selectedResource.id
      ResourceState().then(res => {
        res.custom_list_values.forEach(value => {
          if (value.name === 'IDLE') {
            body.resource_state = value.id
          }
        })
        body.resource_skills_associations = {}
        body.resource_skills_associations = this.newResource.skillsRequired
        if (this.newResource.maintainanceWindow.unit === 'Days') {
          body.maintenance_window = this.newResource.maintainanceWindow.interval
          body.maintenance_window_type = config.DURATION_TYPE_REVERSE_MAP.Days
        } else {
          body.maintenance_window = 1
          body.maintenance_window_type = config.DURATION_TYPE_REVERSE_MAP[this.newResource.maintainanceWindow.unit]
        }
        if (this.partIdRules.length) {
          const sequenceInput = this.partIdValues.map((value) => {
            return {
              value: value.value,
              delimiter: value.delimiter,
              sequence: value.sequence
            }
          })
          body.sequence_input = sequenceInput
        }
        CreateResourceInstance(body).then(() => {
          this.$emit('resource-added')
        }).catch(() => {
          alert('Failed to create resource instance')
        })
      }).catch(() => {
        alert('Failed to fetch resource states')
      })
    },
    validateData () {
      let valid = true
      if (!this.newResource.name.trim()) {
        valid = false
      }
      if (this.newResource.skillsRequired.length === 0) {
        valid = false
      }
      if (!this.selectedResource) {
        valid = false
      }
      if (this.partIdRules.length && !this.validatePartIdValues()) {
        return false
      }
      if (!valid) {
        alert('Please fill all the required fields')
      }
      return valid
    },
    getResources () {
      this.loadingResources = true
      GetResourceTypes().then(res => {
        for (const item of res.custom_list_values) {
          this.resourceType[item.name] = item.id
        }
        GetResourcesFromResourceMaster(this.resourceType[this.selectedType]).then((res) => {
          this.resources = res.core_material_master
        }).catch(() => {
          alert('Failed to fetch resources')
        })
      }).catch(() => {
        alert('Failed to fetch resources')
      }).finally(() => {
        this.loadingResources = false
      })
    },
    getSkills () {
      GetSkillsRequired().then((res) => {
        this.skills = res.custom_list_values
      }).catch(() => {
        alert('Failed to fetch skills')
      })
    },
    handleSkillSelection (val) {
      this.newResource.skillsRequired = val
    },
    handleMaintainanceWindow (value) {
      this.newResource.maintainanceWindow = value
    },
    cancel () {
      this.$emit('cancel')
    },
    selectType (type) {
      this.selectedType = type
      this.partIdValues = []
      this.getResources()
    },
    handleResourceSelection (resource) {
      this.selectedResource = resource
    },
    handleResourceDeselection () {
      this.selectedResource = null
    }
  }
}
</script>

<style scoped lang="scss">
.required-asterisk {
  color: var(--brand-color-1);
  font-size: 1.2em;
  margin-left: 0.1em;
}
.add-resource {
     width: 436px;
    .change-type-bar {
        gap: 180px;
        padding-bottom: 10px;
        border-bottom: 1px solid #d1d5db;
        .change-type-link {
            color: var(--brand-color-1);
            text-decoration: underline;
            opacity: 0.8;
            &:hover {
                opacity: 1;
            }
        }
    }

    .machine-form {
      padding-right: 5px;
      max-height: 60vh;
      overflow-y: auto;
    }
    .tool-form {
      padding-right: 5px;
      max-height: 60vh;
      overflow-y: auto;
    }

    .type-select-menu {
        margin-top: 20px;
    }

    .title {
        font-size: var(--text-s);
        font-weight: 200;
        color: #111827;
        margin-bottom: 12px;
    }

    .options {
        display: flex;
        gap: 14px;

        .option-card {
            flex: 1;
            min-width: 188px;
            border: 1px solid #e5e7eb;
            border-radius: 10px;
            padding: 25px 16px 25px;
            text-align: center;
            cursor: pointer;
            background: #fff;
            transition: border-color 0.15s ease, box-shadow 0.15s ease;

            &:hover {
                border-color: #d1d5db;
                box-shadow: 0 4px 10px rgba(0, 0, 0, 0.05);
            }

            .icon {
                font-size: 22px;
                margin-bottom: 8px;
                color: #6b7280;
            }

            h4 {
                font-size: var(--text-s);
                font-weight: 600;
                margin: 4px 0 2px;
                color: #111827;
            }

            p {
                font-size: var(--text-xs1);
                color: #6b7280;
                margin: 0;
            }
        }
    }
}
</style>
